import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { PaymentDevice } from '../models';
import { Observable } from 'rxjs';
import { HttpHelper } from 'eightcap-core/helpers';
import { map } from 'rxjs/operators';

@Injectable()
export class PaymentDeviceService extends CrudBaseService<PaymentDevice> {

    constructor(httpClient: HttpClient) {
        super('/payment_device', httpClient);
    }

    listPaymentDeviceData(type: string, filterValue?: string): Observable<any> {
        const options = filterValue
            ? {
                  filters: 'users_linked[].id[eq]=' + filterValue
              }
            : {};
        return this.httpClient
            .get(`${this.basePath}/${type}`, { params: HttpHelper.objectToHttpParams({ ...options }) })
            .pipe(
                map((res: any) => {
                    if (res && res.data) {
                        return res.data;
                    }
                })
            );
    }

    filterPaymeroType(filterValue: string, type: string): Observable<any> {
        const options = {
            filters: 'payload.type[eq]=' + filterValue
        };
        return this.httpClient
            .get(`${this.basePath}/${type}`, { params: HttpHelper.objectToHttpParams({ ...options }) })
            .pipe(
                map((res: any) => {
                    if (res && res.data) {
                        return res.data;
                    }
                })
            );
    }
}
